import { Navigate } from 'react-router-dom';

import { ReactElement } from 'react';

interface GuardRouteProps {
  allow: boolean;
  redirectTo?: string;
  children: ReactElement;
}

const GuardRoute = ({ allow, children, redirectTo = '/' }: GuardRouteProps) =>
  allow ? children : <Navigate to={redirectTo} replace />;

export default GuardRoute;
